import React, { createContext, useContext, useState } from 'react';

const PlatformAuthContext = createContext(null);

export const PlatformAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem('platform_admin');
    return stored ? JSON.parse(stored) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem('platform_token'));

  const login = async (email, password) => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const res = await fetch(`${API}/api/platform/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Login failed');
    
    localStorage.setItem('platform_token', data.data.access_token);
    localStorage.setItem('platform_admin', JSON.stringify(data.data.user));
    setToken(data.data.access_token);
    setAdmin(data.data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('platform_token');
    localStorage.removeItem('platform_admin');
    setToken(null);
    setAdmin(null);
  };

  const apiFetch = async (path, options = {}) => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const res = await fetch(`${API}/api/platform${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...(options.headers || {})
      }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Request failed');
    return data;
  };

  return (
    <PlatformAuthContext.Provider value={{ admin, token, login, logout, apiFetch }}>
      {children}
    </PlatformAuthContext.Provider>
  );
};

export const usePlatformAuth = () => {
  const ctx = useContext(PlatformAuthContext);
  if (!ctx) throw new Error('usePlatformAuth must be inside PlatformAuthProvider');
  return ctx;
};
